import danish from "translations/languages/da.json";
import english from "translations/languages/en.json";
import spanish from "translations/languages/es.json";
import finnish from "translations/languages/fi.json";
import norwegian from "translations/languages/nb.json";
import swedish from "translations/languages/sv.json";
import dutch from "translations/languages/nl.json";
import dutchBelgium from "translations/languages/nl-BE.json";
import french from "translations/languages/fr.json";
import frenchBelgium from "translations/languages/fr-BE.json";
import estonian from "translations/languages/et.json";
import lithuanian from "translations/languages/lt.json";
import latvian from "translations/languages/lv.json";
import german from "translations/languages/de.json";
import germanBelgium from "translations/languages/de-BE.json";

export const resources = {
    en: {
        translation: english,
    },
    sv: {
        translation: swedish,
    },
    nb: {
        translation: norwegian,
    },
    da: {
        translation: danish,
    },
    fi: {
        translation: finnish,
    },
    es: {
        translation: spanish,
    },
    nl: {
        translation: dutch,
    },
    "nl-BE": {
        translation: dutchBelgium,
    },
    fr: {
        translation: french,
    },
    "fr-BE": {
        translation: frenchBelgium,
    },
    et: {
        translation: estonian,
    },
    lt: {
        translation: lithuanian,
    },
    lv: {
        translation: latvian,
    },
    de: {
        translation: german,
    },
    "de-BE": {
        translation: germanBelgium,
    },
} as const;

export const supportedLanguages = Object.keys(resources) as Array<keyof typeof resources>;
